import { motion } from "framer-motion";
import { Zap } from "lucide-react";

const NODES = [
  { mode: "Express", logo: "fedex", brand: "FedEx" },
  { mode: "Surface", logo: "delhivery", brand: "Delhivery" },
  { mode: "COD", logo: "xpressbees", brand: "XpressBees" },
  { mode: "B2B", logo: "ups", brand: "UPS" },
  { mode: "Intl", logo: "dhl", brand: "DHL" },
  { mode: "Hyperlocal", logo: "ekart", brand: "Ekart" },
];

export default function CourierNetwork() {
  return (
    <section className="relative overflow-hidden bg-[#030B18] py-20 sm:py-24" data-testid="courier-network">
      <div className="mx-auto grid max-w-7xl items-center gap-12 px-5 lg:grid-cols-2">
        <motion.div initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.6 }}>
          <span className="text-xs font-bold uppercase tracking-[0.22em] text-shipany-cyan">Courier Network</span>
          <h2 className="font-display mt-3 text-2xl font-bold tracking-tight text-white sm:text-3xl lg:text-4xl">
            One Integration. <span className="text-saffron-green">A Network of Couriers.</span>
          </h2>
          <p className="mt-4 max-w-lg text-sm leading-relaxed text-slate-400 sm:text-base">
            Connect once to ShipAny and unlock a managed network of courier partners — compared, routed and tracked from a single dashboard. Official brand marks of our partner network.
          </p>
          <div className="mt-7 flex flex-wrap gap-2">
            {["Rate comparison", "Smart routing", "Unified tracking", "COD support"].map((t) => (
              <span key={t} className="rounded-full border border-white/10 bg-white/5 px-4 py-1.5 text-xs font-semibold text-slate-300">{t}</span>
            ))}
          </div>
        </motion.div>

        <motion.div initial={{ opacity: 0, scale: 0.94 }} whileInView={{ opacity: 1, scale: 1 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.7 }}
          className="relative mx-auto aspect-square w-full max-w-[420px]">
          <svg viewBox="0 0 100 100" className="absolute inset-0 h-full w-full">
            <circle cx="50" cy="50" r="38" fill="none" stroke="rgba(18,200,245,0.15)" strokeWidth="0.4" />
            <circle cx="50" cy="50" r="38" fill="none" stroke="rgba(255,153,51,0.35)" strokeWidth="0.5" className="route-dash" />
            <circle cx="50" cy="50" r="26" fill="none" stroke="rgba(16,185,129,0.25)" strokeWidth="0.4" className="route-dash-fast" />
          </svg>
          <div className="absolute inset-0 wheel-spin" style={{ "--wheel-dur": "70s" }}>
            {NODES.map((n, i) => {
              const a = (i * 60 * Math.PI) / 180;
              const x = 50 + 38 * Math.sin(a);
              const y = 50 - 38 * Math.cos(a);
              return (
                <div key={n.mode} className="absolute" style={{ left: `${x}%`, top: `${y}%`, transform: "translate(-50%,-50%)" }}
                  data-testid={`network-node-${n.mode.toLowerCase()}`}>
                  <div className="wheel-spin-rev flex flex-col items-center" style={{ "--wheel-dur": "70s" }}>
                    <span className="flex h-14 w-14 items-center justify-center rounded-2xl border border-white/25 bg-white/95 p-2 shadow-lg transition-all duration-300 hover:border-[#FF9933]/60 hover:shadow-[0_0_20px_rgba(255,153,51,0.35)]">
                      <img src={`/courier-logos/${n.logo}.png`} alt={n.brand} className="max-h-full max-w-full object-contain" />
                    </span>
                    <span className="mono mt-1 text-[8px] font-bold uppercase tracking-wider text-slate-500">{n.mode}</span>
                  </div>
                </div>
              );
            })}
          </div>
          <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
            <div className="node-glow flex h-24 w-24 flex-col items-center justify-center rounded-full border border-shipany-cyan/40 bg-[#071B3A]">
              <Zap className="h-5 w-5 text-[#FF9933]" />
              <span className="font-display text-sm font-extrabold text-white">SHIPANY</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
